import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Alert,
  InputAdornment
} from '@mui/material';
import { DealData, AiInsights } from '@features/deals/types';
import BusinessIcon from '@mui/icons-material/Business';

interface SaveDealStepProps {
  dealData: DealData;
  setDealData: React.Dispatch<React.SetStateAction<DealData>>;
  aiInsights: AiInsights | null;
  saveStatus: 'idle' | 'success' | 'error';
  error: string | null;
}

const SaveDealStep: React.FC<SaveDealStepProps> = ({
  dealData,
  setDealData,
  aiInsights,
  saveStatus,
  error
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Finalize Deal
      </Typography>
      <Box sx={{ maxWidth: 500, mx: 'auto' }}>
        <TextField
          label="Deal Name"
          fullWidth
          margin="normal"
          value={dealData.name}
          onChange={(e) => setDealData({ ...dealData, name: e.target.value })}
          error={!dealData.name.trim()}
          helperText={!dealData.name.trim() && 'Required field'}
          InputProps={{
            endAdornment: <BusinessIcon color="action" />,
          }}
        />

        <TextField
          label="Asking Price"
          fullWidth
          margin="normal"
          value={dealData.asking_price}
          onChange={(e) => setDealData({ ...dealData, asking_price: e.target.value })}
          error={isNaN(parseFloat(dealData.asking_price))}
          helperText={
            isNaN(parseFloat(dealData.asking_price))
              ? 'Valid number required'
              : 'Recommended range: $' + (aiInsights?.valuationEstimate.low ?? 0).toLocaleString() + ' - $' + (aiInsights?.valuationEstimate.high ?? 0).toLocaleString()
          }
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />

        {saveStatus === 'success' && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Deal saved successfully! Redirecting to details page...
          </Alert>
        )}

        {saveStatus === 'error' && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error || 'Failed to save deal. Please try again.'}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default SaveDealStep;